import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import LinearProgress from '@material-ui/core/LinearProgress'

const useStyles = makeStyles({
  root: {
    zIndex: 2000,
    width: '100%',
    position: 'absolute',
    top: '80px',
    left: 0,
    '& .MuiLinearProgress-colorPrimary': {
      backgroundColor: '#fc785561',
    },
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: '#FC7855 !important',
    },
  },
  loadingText: {
    marginTop: '300px',
    width: '100%',
    textAlign: 'center',
    fontАamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '24px',
    color: '#FE794E',
  },
})

const LinearDeterminate = ({ visible }) => {
  const classes = useStyles()
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(oldProgress => {
        if (oldProgress === 100) {
          return 0
        }
        const diff = Math.random() * 10
        return Math.min(oldProgress + diff, 100)
      })
    }, 500)

    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <div className={classes.root}>
      <LinearProgress variant='determinate' value={progress} />
      {visible && <div className={classes.loadingText}>Gathering all the stories...</div>}
    </div>
  )
}

export default LinearDeterminate
